export default __webpack_public_path__ + "static/media/how-to-start.ccb538ab.jpg";